var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8451C0 6.64154 9.42217 -0.955061 19.3935 1.20907L46.6065 7.11522C48.8428 7.60058 51.1572 7.60058 53.3936 7.11522L80.6065 1.20907C90.5778 -0.955061 100 6.64154 100 16.8451V128.107C100 133.631 97.1514 138.763 92.4644 141.685L57.3463 163.578C52.0451 166.883 45.3052 166.8 40.0867 163.366L7.20481 141.728C2.7075 138.769 0 133.746 0 128.363V16.8451Z",
    fill: "url(#paint0_linear_1266_30084)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 16.8451C1 7.27926 9.83329 0.157446 19.1814 2.18632L46.3944 8.09247C48.7705 8.60816 51.2295 8.60816 53.6056 8.09247L80.8186 2.18632C90.1667 0.157446 99 7.27925 99 16.8451V128.107C99 133.285 96.3294 138.097 91.9354 140.837L56.8173 162.729C51.8474 165.827 45.5288 165.75 40.6364 162.531L7.75451 140.893C3.53828 138.119 1 133.41 1 128.363V16.8451Z",
    stroke: "url(#paint1_linear_1266_30084)",
    strokeOpacity: 0.28,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_30084",
    x1: 50,
    y1: -3,
    x2: 50,
    y2: 98.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1266_30084",
    x1: 49.8512,
    y1: 168.488,
    x2: 49.8512,
    y2: 80.2221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9B9B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelBackground);
export default __webpack_public_path__ + "static/media/level_background.3c251f13392c8b34e752aae846aad203.svg";
export { ForwardRef as ReactComponent };